import { Component } from 'react';
import cx from 'classnames';

import styles from '../../styles/plan/faq.scss';
import SectionHeader from './sectionHeader';

interface FaqData {
  question: string;
  answer: string;
}

interface State {
  open: boolean;
}

interface Props {
  data: FaqData;
  mandate: boolean;
  showTitle?: boolean;
}

class Group extends Component<Props, State> {
  constructor(props: any) {
    super(props);
    this.state = {
      open: props.mandate || false,
    };
  }
  public render() {
    const { open } = this.state;
    const { question, answer } = this.props.data;
    return (
      <li className={styles.group}>
        <label
          className={styles.question}
          onClick={() =>
            this.setState({
              open: !open,
            })
          }
        >
          {question}
        </label>
        <div
          className={cx(styles.answer, { hidden: !open })}
          dangerouslySetInnerHTML={{ __html: answer }}
        />
      </li>
    );
  }
}

// tslint:disable-next-line:max-classes-per-file
class FAQ extends Component<any, any> {
  constructor(props: any) {
    super(props);
    this.state = {
      readMore: false,
    };
  }
  public render() {
    const { readMore } = this.state;
    const { faqs, mandate, hideReadMore, title, showTitle = true } = this.props;
    const faqsToLoad = hideReadMore || readMore ? faqs : faqs.slice(0, 5);
    return (
      <div
        className={cx(styles.faq, { [styles.mandate]: mandate }, 'faq-block')}
      >
        {showTitle ? (
          <SectionHeader
            mandate={mandate}
            title={title || 'Frequently Asked Questions'}
          />
        ) : null}
        <ul className={cx(styles['faqs'], !showTitle ? 'mt30' : null)}>
          {faqsToLoad.map(group => (
            <Group mandate={mandate} data={group} key={group.answer} />
          ))}
          {hideReadMore ? null : (
            <li
              className={styles['read-more']}
              key={'read-more'}
              onClick={() =>
                this.setState({
                  readMore: !readMore,
                })
              }
            >
              {readMore ? 'Read Less' : 'Read More'}
            </li>
          )}
        </ul>
      </div>
    );
  }
}

export default FAQ;



// WEBPACK FOOTER //
// ./components/plan/faq.tsx